import React from 'react'
import { SpinnerElement, SpinnerWrapper } from './style'

const Spinner = ({size}) => {
  return (
    <SpinnerWrapper>
      <SpinnerElement size={size} />
    </SpinnerWrapper>
  )
}

export default Spinner